"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERR_MSG_RECOVERER_MUST_RETURN_PROMISE = exports.ERR_MSG_TRANSFORMER_MUST_RETURN_PROMISE = exports.ERR_MSG_RECOVERER_MUST_NOT_RETURN = exports.ERR_MSG_DEFAULT_VALUE_MUST_NOT_BE = exports.ERR_MSG_CALLED_WITH = exports.ERR_MSG_TRANSFORMER_MUST_NOT_RETURN = void 0;
var ERR_MSG_MUST_RETURN_PROMISE = ' must return Promise';
var ERR_MSG_MUST_NOT_RETURN = ' must not return ';
var TRANSFORM_FUNCTION_NAME = '`transformer`';
var RECOVERY_FUNCTION_NAME = '`recoverer`';
var DEFAULT_VALUE_NAME = '`defaultValue`';
exports.ERR_MSG_TRANSFORMER_MUST_NOT_RETURN = TRANSFORM_FUNCTION_NAME + ERR_MSG_MUST_NOT_RETURN;
exports.ERR_MSG_CALLED_WITH = 'called with ';
exports.ERR_MSG_DEFAULT_VALUE_MUST_NOT_BE = DEFAULT_VALUE_NAME + ' must not be ';
exports.ERR_MSG_RECOVERER_MUST_NOT_RETURN = RECOVERY_FUNCTION_NAME + ERR_MSG_MUST_NOT_RETURN;
exports.ERR_MSG_TRANSFORMER_MUST_RETURN_PROMISE = TRANSFORM_FUNCTION_NAME + ERR_MSG_MUST_RETURN_PROMISE;
exports.ERR_MSG_RECOVERER_MUST_RETURN_PROMISE = RECOVERY_FUNCTION_NAME + ERR_MSG_MUST_RETURN_PROMISE;
